import { render } from "./Navigation.vue?vue&type=template&id=1f81ce5f&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=1f81ce5f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f81ce5f"

export default script